import { createVanIconComponent } from "./van"

const PendingPayment = createVanIconComponent("pending-payment")
export default PendingPayment
